<template src="./Form.html"></template>

<script>
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';

export default {
  validations: {
    email: { required },
  },

  data() {
    return {
      isSend: false,
      isSendForm: false,
      email: '',
      name: '',
    };
  },

  methods: {
    async sendForm() {
      if (this.isSendForm) return false;
      if (this.$v.$invalid) {
        this.$v.$touch();
        return false;
      }
      this.isSendForm = true;
      const result = await axios.post('/api/contacts/', { name: this.name, info: this.email });
      if (result.status === 201) {
        this.isSend = true;
      }
      return undefined;
    },
  },

};
</script>

<style lang="scss" scoped>
@import "~styles/vars.scss";

.form{
  background-color: $light-blue;
  width: 100%;
  padding-top: 170px;

  @media only screen and (max-width : $tablet){
    padding-top: 91px;
  }

  @media only screen and (max-width : $phone){
    padding-top: 25vw;
  }
}

.form_wrapper{
  width: 1075px;
  margin: 0 auto;
  display: flex;
  box-sizing: border-box;

  &.-send{
    min-height: 434px;
    display: block;
  }

  @media only screen and (max-width : $tablet){
    width: 634px;
    display: block;
  }

  @media only screen and (max-width : $phone){
    width: calc(100% - 10vw);
    padding-bottom: 7.8125vw;
  }
}

.form_block{
  width: 50%;
  display: block;
  padding-bottom: 170px;

  @media only screen and (max-width : $tablet){
    width: 100%;
    padding-bottom: 94px;
    position: relative;
  }

  @media only screen and (max-width : $phone){
    padding-bottom: 17.5vw;
  }
}

.form_text{
  font-size: 18px;
  line-height: 33px;
  letter-spacing: 2px;
  box-sizing: border-box;
  padding-right: 75px;

  @media only screen and (max-width : $tablet){
    width: 440px;
    padding-right: 0;
  }

  @media only screen and (max-width : $phone){
    font-size: 3.75vw;
    line-height: 6.875vw;
    letter-spacing: 0.46875vw;
    width: 66vw;
  }
}

.form_input{
  width: 100%;
  border: none;
  background-color: transparent;
  border-bottom: 1px solid $light-gray;
  color: $soft-gray;
  font-size: 30px;
  font-family: $playfair;
  outline: none;
  padding-bottom: 8px;
  margin-top: -10px;
  margin-bottom: 57px;

  &.error{
    border-color: #d0021b;
  }

  @media only screen and (max-width : $phone){
    font-size: 6.25vw;
    padding-bottom: 1.875vw;
    margin-top: -1.5625vw;
    margin-bottom: 7.8125vw;
  }

  &::placeholder {
    color: $soft-gray;
    opacity: 1;
  }

  &:-ms-input-placeholder {
    color: $soft-gray;
  }

  &::-ms-input-placeholder {
    color: $soft-gray;
  }
}

.form_button{
  @media only screen and (max-width : $phone){
    width: 100%;
    margin-top: 7.8125vw;
    font-size: 3.75vw;
    letter-spacing: 0.46875vw;
    height: 17.1875vw;
  }
}

.error_message{
  color: #d0021b;
  font-size: 16px;
  position: absolute;
  margin-top: -52px;
  font-weight: 100;

  @media only screen and (max-width : $phone){
    margin-top: -6vw;
  }
}

.form_title{
  font-size: 48px;
  font-family: $playfair;
  display: block;
  text-align: center;
  width: 100%;
  padding-top: 65px;

  @media only screen and (max-width : $phone){
    font-size: 6.875vw;
    padding-top: 10.15625vw;
  }
}

.form_subtitle{
  font-size: 16px;
  text-align: center;
  font-weight: 100;
  padding-top: 30px;
  width: 330px;
  margin: 0 auto;
  display: block;

  @media only screen and (max-width : $phone){
    font-size: 3.75vw;
    padding-top: 5vw;
    width: 88vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/Form.vue